import React, { useRef, useState } from 'react'
import SimpleTextBox from '../FormElements/SimpleTextBox'
import { useTranslation } from "next-i18next";
import { useRouter } from 'next/router';

const SearchInput = () => {
    const { t } = useTranslation(["blog"]);
    const router = useRouter();
    const searchRef = useRef(null);
    const [searchValue, setSearchValue] = useState('');

    const currentLang = router.asPath.includes("/blog/en") ? "en" : "tr";

    const handleSearch = () => {
        if (searchValue) {
            router.push(`/blog/${currentLang}/${currentLang === 'tr' ? 'arama' : 'search'}?query=${encodeURIComponent(searchValue)}`);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            searchRef.current?.click();
        }
    };
    return (
        <div className='flex py-4'>
            <SimpleTextBox
                value={searchValue}
                onChange={setSearchValue}
                inputName="search"
                placeholder={t("blog:search")}
                onKeyDown={handleKeyDown}
            />
            <a ref={searchRef} href={`/blog/${currentLang}/${currentLang === 'tr' ? 'arama' : 'search'}?query=${encodeURIComponent(searchValue)}`}>
                <button className='h-[39px] mt-6 lg:mt-1 -ml-4 lg:-ml-8 p-4 rounded-r-md flex items-center text-white bg-black' >
                    {t("blog:search")}< i className="mt-1 ml-2 text-lg ri-search-line"></i>
                </button>
            </a>
        </div>
    )
}

export default SearchInput